module.exports = __webpack_public_path__ + "img/logo-mc.16ec35d6.svg";